var paper = require("./../../../bower_components/paper/dist/paper-core.js");

module.exports = paper;